import { ExecutionStep, ExecutionStepResult, PipelineExecutionState } from '@/interfaces/pipelineExecution.interface';
import SmartToyIcon from '@mui/icons-material/SmartToy';
import { Box, LinearProgress, Typography } from '@mui/material';
import PipelineHorizontalStepper from '../pipelineView/pipelineHorizontalStepper';
import StepViewer from '../pipelineView/stepViewer';

type Props = {
  pipelineExecutionState: PipelineExecutionState;
  selectedStep?: ExecutionStep | null;
  executingStepId?: string | null;
  stepExecutionResponse?: ExecutionStepResult | null;
  suppressEvents?: boolean;
  onToggleSuppressEvents?: (value: boolean) => void;
  onSelectStep: (step: ExecutionStep) => void;
  onClearStepExecutionResponse: () => void;
  onExecuteStep: (
    step: ExecutionStep,
    options?: { inputOverride?: any; reingest?: boolean; suppressEvents?: boolean },
  ) => void;
  onRestartFromPoint: (step: ExecutionStep, eventDataId?: string | number) => void;
  onChange: () => void;
};

const PipelineExecutionPanel = ({
  pipelineExecutionState,
  selectedStep,
  executingStepId,
  stepExecutionResponse,
  suppressEvents,
  onToggleSuppressEvents,
  onSelectStep,
  onClearStepExecutionResponse,
  onExecuteStep,
  onRestartFromPoint,
  onChange,
}: Props) => {
  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', height: '100%', minHeight: 0, flexGrow: 1, overflow: 'hidden' }}>
      {executingStepId && <LinearProgress color="secondary" sx={{ height: 3 }} />}
      {pipelineExecutionState.steps && pipelineExecutionState.steps.length > 0 && (
        <PipelineHorizontalStepper
          pipelineName={pipelineExecutionState.pipelineName}
          pipelineStatus={pipelineExecutionState.status}
          steps={pipelineExecutionState.steps}
          selectedStep={selectedStep}
          onSelectStep={onSelectStep}
          runningStepIndex={
            executingStepId ? pipelineExecutionState.steps.findIndex((s) => s.id === executingStepId) : null
          }
        />
      )}
      <Box sx={{ flexGrow: 1, overflow: 'hidden', display: 'flex', flexDirection: 'column', bgcolor: '#ffffff' }}>
        {selectedStep ? (
          <StepViewer
            step={selectedStep}
            pipelineExecutionState={pipelineExecutionState}
            suppressEvents={suppressEvents}
            onToggleSuppressEvents={onToggleSuppressEvents}
            isExecuting={executingStepId === selectedStep.id}
            stepExecutionResponse={stepExecutionResponse}
            onClearStepExecutionResponse={onClearStepExecutionResponse}
            onExecuteStep={onExecuteStep}
            onRestartFromPoint={onRestartFromPoint}
            onChange={onChange}
          />
        ) : (
          <Box
            sx={{
              flexGrow: 1,
              p: 4,
              display: 'flex',
              flexDirection: 'column',
              justifyContent: 'center',
              alignItems: 'center',
              bgcolor: '#f8fafc',
            }}
          >
            <SmartToyIcon sx={{ fontSize: 44, color: '#94a3b8', mb: 2 }} />
            <Typography variant="body1" color="text.secondary" align="center" sx={{ fontWeight: 600 }}>
              Select a step above to inspect details
            </Typography>
          </Box>
        )}
      </Box>
    </Box>
  );
};

export default PipelineExecutionPanel;
